namespace Areas.ContractorPay.EnterPayment{
    "use strict";

    let contractScheduleValueId: number;
    let runQuery: boolean = false;

    export function onNewTransactionRow(e: any) {
        e.data.contractScheduleValueProfileId = e.component.option("ContractScheduleValueProfileId");
    }


    export function forceSendingAllRowValues(options) {
        options.newData = $.extend({}, options.oldData, options.newData); 
    }

     export function setCurrentBillingValue(rowData, value) {
        const grid = $("#EnterPaymentDetailGrid").dxDataGrid("instance");
        rowData.currentBilling = value;
        const retention = value * Number(grid.option("RetentionPercentage"));
        rowData.currentRetention = retention;
    }

    export function getContractScheduleValueId() {
        return contractScheduleValueId;
    }

    export function canExecuteQuery() {
        return runQuery;
    }

    export function getDataForDocDate(e: any) {
        const grid = $("#EnterPaymentGrid").dxDataGrid("instance");

        let selectedRows = grid.getSelectedRowsData();

        if (selectedRows.length === 1) {
            runQuery = true;
            contractScheduleValueId = selectedRows[0].contractScheduleValueId;
            Areas.refreshGrid("EnterPaymentDetailGrid");
        }
    }


    export function goToActions(projectInfoId: number, sharePointLink: string) {
        return (e: any) => {
            if (e.value == 1) {
                goToSharePoint(sharePointLink);
                clearSelectBoxSelection(e);
                return;
            }
            if (e.value == 2) {
                goToPIFPAF(projectInfoId);
                clearSelectBoxSelection(e);
                return;
            }
        }
    }

    function goToSharePoint(sharePointLink: string) {
        if (sharePointLink != null) {
            Areas.websiteSharePoint(sharePointLink);
        }
        return
    }

    function goToPIFPAF(projectInfoId: number) {
        let linkInfo = "https://projectinitiation.capnet.ucla.edu/Requests/View/Index/" + projectInfoId + "";
        window.open(linkInfo);
    }
}